import { Injectable } from '@angular/core';
import { State } from '@ngxs/store';
import { HttpService } from '../../core/services/http/http.service';
import { IFuenteGas } from '../../core/interfaces/sections.interface';
import { MatDialog } from '@angular/material/dialog';

export interface GasSourcesStateModel {
  gasSources: IFuenteGas[];
}

@State<GasSourcesStateModel>({
  name: 'GasSources',
  defaults: {
    gasSources: [],
  },
})
@Injectable()
export class GasSourcesState {
  constructor(
    private httpService: HttpService,
    private dialog: MatDialog
  ) {}
}
